<template>
    <BasePanel
        v-model="enabled"
        title="Nota fiscal"
        @closePanel="$emit('closePanel')">
        <span slot="label">Enviar NFCe</span>
        <div>
            <vs-input v-model="cpf" :disabled="!enabled" class="w-full mt-2" label="CPF NA NOTA" placeholder="opcional"/>
            <vs-input v-model="name" :disabled="!enabled" class="w-full mt-2" label="NOME" placeholder="opcional"/>
            <vs-divider/>
            <div class="flex justify-between my-2">
                Imprimir?
                <vs-checkbox v-model="print" :disabled="!enabled"/>
            </div>
        </div>
    </BasePanel>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
    import BasePanel from './BasePanel';
    export default {
        components: {
            BasePanel,
        },
        props: {
            value: {
                type: Boolean
            },
        },
        data() {
            return {
            }
        },
        computed: {
            enabled: {
                get () {
                    this.setNfce({ ...this.nfce, enabled: this.value });
                    return this.value 
                },
                set (v) {
                    this.setNfce({ ...this.nfce, enabled: v });
                    this.$emit('input', v);
                }
            },
            cpf: {
                get () { return this.nfce.cpf; },
                set (v) { this.setNfce({ ...this.nfce, cpf: v }); }
            },
            name: {
                get () { return this.nfce.name; },
                set (v) { this.setNfce({ ...this.nfce, name: v }); }
            },
            print: {
                get () { return this.nfce.print; },
                set (v) { this.setNfce({ ...this.nfce, print: v }); }
            },
            ...mapState('payment', ['nfce'])
        },
        methods: mapMutations('payment', ['setNfce'])
    }
</script>

<style lang="scss" scoped>

</style>